var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74407 0.410765C9.0695 0.0853278 9.59714 0.0853278 9.92258 0.410765L14.9226 5.41076C15.248 5.7362 15.248 6.26384 14.9226 6.58928L9.92258 11.5893C9.59714 11.9147 9.0695 11.9147 8.74407 11.5893C8.41863 11.2638 8.41863 10.7362 8.74407 10.4108L12.3215 6.83335H0.99999C0.539753 6.83335 0.166656 6.46026 0.166656 6.00002C0.166656 5.53978 0.539753 5.16669 0.99999 5.16669H12.3215L8.74407 1.58928C8.41863 1.26384 8.41863 0.736202 8.74407 0.410765Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowRight);
export default __webpack_public_path__ + "static/media/icn-arrow-right.da6d9031e2b60b44d00aeb5fb392cb2b.svg";
export { ForwardRef as ReactComponent };